export default __webpack_public_path__ + "static/media/icon_refresh_20_regular.7accf149.svg";